import { render } from "./PostImg.vue?vue&type=template&id=6e0ae02a&scoped=true"
import script from "./PostImg.vue?vue&type=script&lang=js"
export * from "./PostImg.vue?vue&type=script&lang=js"

import "./PostImg.vue?vue&type=style&index=0&id=6e0ae02a&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0ae02a"]])

export default __exports__